module.exports = __webpack_public_path__ + "img/qrcode.94ae543b.jpg";